/** Small inline SVG margin doodles (stars, suns, arrows…) drawn with wobbly strokes. */
const PATHS: Record<string, string> = {
  star: '<path d="M30 4 L37 22 L56 23 L41 35 L46 54 L30 43 L14 54 L19 35 L4 23 L23 22 Z" fill="#f6d55c" fill-opacity=".55"/>',
  sun: '<circle cx="30" cy="30" r="12" fill="#f3a712" fill-opacity=".45"/><path d="M30 4v8M30 48v8M4 30h8M48 30h8M11 11l6 6M43 43l6 6M11 49l6-6M43 17l6-6"/>',
  heart: '<path d="M30 52 C 6 34, 6 12, 22 12 C 28 12, 30 18, 30 20 C 30 18, 32 12, 38 12 C 54 12, 54 34, 30 52 Z" fill="#ff8fab" fill-opacity=".5"/>',
  arrow: '<path d="M6 40 C 20 20, 36 18, 52 22 M44 12 L54 22 L42 30"/>',
  cloud: '<path d="M14 42 C 4 42, 4 28, 14 28 C 14 16, 30 14, 34 24 C 40 16, 54 20, 52 30 C 60 32, 58 44, 48 42 Z" fill="#a9c6e8" fill-opacity=".4"/>',
  skull: '<circle cx="30" cy="26" r="16"/><path d="M22 40v10h16V40"/><circle cx="24" cy="25" r="4" fill="#3b3b3b"/><circle cx="36" cy="25" r="4" fill="#3b3b3b"/>',
  crown: '<path d="M8 46 L12 18 L22 32 L30 12 L38 32 L48 18 L52 46 Z" fill="#f6d55c" fill-opacity=".6"/>',
  pencil: '<path d="M10 50 L14 38 L44 8 L52 16 L22 46 Z" fill="#f6d55c" fill-opacity=".6"/><path d="M14 38 L22 46"/>',
  spiral: '<path d="M30 30 m0 0 c4 0 4 6 0 6 c-8 0 -8 -12 0 -12 c12 0 12 18 0 18 c-16 0 -16 -24 0 -24"/>',
  check: '<path d="M8 32 L24 48 L54 10"/>',
};

export type DoodleName = keyof typeof PATHS;

export function doodleSvg(name: DoodleName | string, cls = ''): SVGSVGElement {
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('viewBox', '0 0 60 60');
  svg.setAttribute('class', `doodle-svg ${name} ${cls}`);
  svg.setAttribute('aria-hidden', 'true');
  svg.innerHTML = `<g fill="none" stroke="#3b3b3b" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" filter="url(#wobble)">${PATHS[name] ?? PATHS.star}</g>`;
  return svg;
}

/** One-time SVG filter definitions (pencil wobble) used by doodles and borders. */
export function installSvgFilters(): void {
  if (document.getElementById('pl-svg-defs')) return;
  const div = document.createElement('div');
  div.innerHTML = `<svg id="pl-svg-defs" width="0" height="0" style="position:absolute" aria-hidden="true">
    <filter id="wobble"><feTurbulence type="fractalNoise" baseFrequency="0.04" numOctaves="2" seed="3"/><feDisplacementMap in="SourceGraphic" scale="2.5"/></filter>
  </svg>`;
  document.body.appendChild(div.firstElementChild!);
}
